/* eslint-disable flowtype/require-return-type */
/* @flow strict */

import * as React from 'react';
import {
  ResponsiveContainer, PieChart, Pie, Cell, Legend, Tooltip, Sector
} from 'recharts';
import { currency } from '/client/src/constants/';

type PropsType = {
  data: any,
  type: string
};

const PieBreakdown = ({ data, type }: PropsType): React.Element<'div'> => {
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

  const [activeIndex, setActiveIndex] = React.useState(null);
  const onMouseOver = React.useCallback((data, index) => setActiveIndex(index), []);
  const onMouseLeave = React.useCallback((): void => setActiveIndex(null), []);

  const renderLegend = (): React.Element<'li'> =>  (
    <ul className='PieLegend' style={{ width: '140px' }}>
      {_.map(data, (entry: {}, index: number) => (
        <li
          key={`item-${index}`}
          className='PieLegendItem'
          onMouseEnter={(): void => setActiveIndex(index)}
          onMouseLeave={(): void => setActiveIndex(null)}
        >
          <span
            className='PieLegendItem-dot'
            style={{
              background: COLORS[index % COLORS.length],
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          />
          <span className="PieLegendItem-text">
             {data[index].name} ({currency[data[index].currency || 'USD']}{data[index].value})
          </span>
        </li>
      ))}
    </ul>
  );

  const renderCustomToolTip = ({ payload }: any): any => {
    if (!payload.length) return;
    return (
      <div
        style={{
          background: 'rgba(255,255,255, .8)',
          border: `1px solid ${COLORS[activeIndex]}`,
          boxShadow: '0 0 3px rgba(0,0,0,0.5)',
          padding: '5px 10px',
          minWidth: '50px'
        }}
      >
        <div style={{ fontSize: '11px' }}>{payload[0].name}</div>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px' }}>
          <span
            className='PieLegendItem-dot'
            style={{
              background: COLORS[activeIndex],
              marginLeft: '0',
              width: '5px',
              height: '5px'
            }}
          />
          {type}: <b>&nbsp;{currency[data[0].currency || 'USD']}{payload[0].value}</b>
        </div>
      </div>
    );
  };

  const renderActiveShape = (props: any): any => {
    const {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle
    } = props;

    return (
      <Sector
        style={{ opacity: '.4' }}
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={COLORS[activeIndex]}
      />
    );
  };

  return (
    <div
      className="panel-body"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '270px',
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto'
      }}
    >
      <ResponsiveContainer width="99%" height={154}>
        <PieChart
          margin={{ top: 0, right: 30, left: 0, bottom: 0 }}
        >
          <Pie
            dataKey="value"
            data={data}
            innerRadius="70%"
            outerRadius="90%"
            fill="#8884d8"
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
          >
            {
              _.map(data, (entry: {}, index: number): void => (
                 <Cell key={`pie3-${index}`} fill={COLORS[index % COLORS.length]} />
              ))
            }
          </Pie>
          <Pie
            dataKey="value"
            data={data}
            innerRadius="90%"
            outerRadius="100%"
            fill="none"
            activeShape={renderActiveShape}
            activeIndex={activeIndex}
          />
          <Legend
            content={renderLegend}
            layout='vertical'
            align='right'
            verticalAlign='middle'
            wrapperStyle={{
              right: '0',
              padding: '0 5%',
              height: '90%',
              overflow: 'auto'
            }}
          />
          <Tooltip content={renderCustomToolTip} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieBreakdown;
